import React, { useState, useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Form, message } from "antd";
import { useParams } from "react-router-dom";
import { translateService } from "../../../ducks/services";
import { getBookingDetail } from "../../../ducks/actions";
import { ActionModal } from "../ActionModal";
import { InputField } from "../../../../../atoms/FormElement";
import { useLeaseTermAmendments } from "../api/v1/useLeaseTermAmendments";

let timeOutId: any = "";
let aTimeOutId: any = "";
var _ = require("lodash");

type LeaseActionModalProps = {
  isOpen: boolean;
  onClose: () => void;
};
type Step = "confirmation" | "finalization";

export const TenantAmendments = (props: LeaseActionModalProps) => {
  const { isOpen, onClose } = props;
  // hooks initialization
  const dispatch: any = useDispatch();
  const { leaseId = "" } = useParams();
  const { loading, error, data, submit } = useLeaseTermAmendments("booking/leaseAmendments");
  // redux states
  const { bookingForm, bookingDetails } = useSelector((state: any) => state.newBooking);

  const {
    control,
    setValue,
    getValues,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const name = useWatch({ control, name: "name" });
  const signatoryName = useWatch({
    control,
    name: "signatoryName",
  });
  const [step, setStep] = useState<Step>("confirmation");
  const usagesType = bookingDetails?.propertyDetails?.usagesType;

  useEffect(() => {
    if (name && name.length > 1) {
      clearTimeout(timeOutId);

      timeOutId = setTimeout(async () => {
        const response = await translateService(name);
        if (response?.translatedText) setValue("arabicName", response?.translatedText);
      }, 2000);
    }

    if (signatoryName && signatoryName.length > 1) {
      clearTimeout(aTimeOutId);

      aTimeOutId = setTimeout(async () => {
        const response = await translateService(signatoryName);
        if (response?.translatedText) setValue("signatoryArabicName", response?.translatedText);
      }, 2000);
    }
  }, [name, signatoryName]);

  const onSubmit = handleSubmit(async (data) => {
    let dataCopy = { ...(data || getValues()) };
    let body = {
      leaseId: leaseId,
      tenantDetails: dataCopy,
    };
    try {
      const response = await submit(body);
      if (response?.code === 200) {
        if (leaseId) dispatch(getBookingDetail(leaseId));
        message.success("Tenant name updated sucessfully");
        onClose();
      }
    } catch (error) {
      message.error(error.response?.data?.error || error.response?.data?.message);
    }
  });

  const handleOk = (data?) => {
    if (step === "confirmation") setStep("finalization");
    else onSubmit(data);
  };

  const resetForm = () => {
    onClose();
    setStep("confirmation");
    reset();
  };

  return (
    <ActionModal
      isOpen={isOpen}
      onClose={onClose}
      title="Tenant Amendments"
      steps={step === "confirmation" ? "Confirm" : "Submit"}
      handleOk={handleOk}
      resetForm={resetForm}
      confirmLoading={loading}
      width={600}
    >
      {step === "confirmation" ? (
        <div>
          <p>Please confirm if you want to update the tenant name.</p>
          <p>Once updated, the previous tenant name will no longer be shown for this lease.</p>
          <p>Are you sure you want to proceed?</p>
        </div>
      ) : (
        <Form
          layout="vertical"
          name="bookingform"
          scrollToFirstError
          className="bf-main"
          onFinish={handleSubmit(onSubmit)}
        >
          <Col span={24}>
            <Row gutter={24}>
              <Col span={24}>
                <InputField
                  fieldname="name"
                  control={control}
                  isRequired={true}
                  setValue={setValue}
                  label="Tenant Name"
                  valueGot={bookingForm["name"]}
                  validate={errors.name && "error"}
                  iProps={{ placeholder: "John Smith" }}
                  validMessage={errors.name && errors.name.message}
                  rules={{ required: "Please enter tenant name" }}
                />
              </Col>

              {usagesType?.toLocaleLowerCase() === "residential" && (
                <Col span={24}>
                  <InputField
                    isRequired={true}
                    disabled={true}
                    control={control}
                    setValue={setValue}
                    fieldname="arabicName"
                    label="Tenant Name Arabic"
                    iProps={{ placeholder: "جون سميث" }}
                    valueGot={bookingForm["arabicName"]}
                    validate={errors.arabicName && "error"}
                    validMessage={errors.arabicName && errors.arabicName.message}
                    rules={{ required: "Please enter tenant arabic name " }}
                  />
                </Col>
              )}
            </Row>
          </Col>
        </Form>
      )}
    </ActionModal>
  );
};
